import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  boxStyle: {
    display: "flex",
    alignItems: "center",
  },
  blueBtn: {
    fontFamily: "Inter",
    padding: "8px 24px",
    borderRadius: "100px",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      opacity: "90%",
    },
    "&.Mui-disabled": {
      backgroundColor: theme.palette.primary.light,
      color: "#D1D8DF",
    },
  },
  dragAndDrop: {
    display: "inline-blok",
    opacity: 0,
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: 50,
  },
  textLeft: {
    textAlign: "left",
    marginLeft: "8px",
  },
  modalStyle: {
    "& .MuiDialog-container .MuiPaper-root ": {
      [theme.breakpoints.up("md")]: {
        width: "576px",
        paddingBottom: "14px",
      },
      "& .MuiGrid-container button": {
        display: "none",
      },
      "& .MuiDialogActions-root": {
        justifyContent: "end",
      },
    },
  },
  folderModalStyle: {
    "& .MuiDialog-container .MuiPaper-root": {
      [theme.breakpoints.up("md")]: {
        paddingTop: "28px",
      },
      "& .MuiGrid-container": {
        "& .MuiDialogTitle-root .MuiTypography-root": {
          fontFamily: "Lato",
          fontSize: theme.typography.pxToRem(20),
          color: theme.palette.common.black,
          marginBottom: 8,
        },
        "& .MuiGrid-item .MuiFormControl-root": {
          marginBottom: 0,
          "& label": {
            fontFamily: "Inter",
            fontWeight: "700",
            fontSize: theme.typography.pxToRem(14),
            color: theme.palette.common.black,
          },
        },
      },
    },
  },
  inputStyle: {
    marginBottom: "16px",
    "& div": {
      "& .MuiFormLabel-root": {
        fontFamily: "Lato",
        fontSize: theme.typography.pxToRem(20),
        color: theme.palette.common.black,
      },
      "&:nth-child(2)": {
        marginTop: "20px",
      },
    },
  },
  cancelBtn: {
    border: "none",
    padding: "10px 30px",
    borderRadius: "28px",
    fontFamily: "Inter",
    color: theme.palette.primary.main,
    "&:hover": {
      border: "none",
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.light,
    },
  },
  addFilebutton: {
    marginLeft: "28px",
  },
  folderIconStyle: {
    width: 24,
    height: 24,
    cursor: "pointer",
  },
  addIcon: {
    fontSize: `${theme.typography.pxToRem(14)} !important`,
  },
  textStyle: {
    "& .MuiOutlinedInput-root": {
      fontFamily: "Inter",
      fontStyle: "normal",
      fontWeight: 400,
      color: theme.palette.common.black,
      borderColor: theme.palette.common.black,
      "& fieldset": {
        borderColor: theme.palette.common.black,
      },
      "&:hover fieldset": {
        borderColor: theme.palette.common.black,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.common.black,
        borderWidth: "1px 1px 4px 1px",
      },
    },
    "& label.Mui-focused": {
      color: theme.palette.common.black,
    },
  },
  interTypo: {
    "& .MuiFormControlLabel-label": {
      fontFamily: "Inter",
    },
  },
}));
